export const GOODS = {
  unitOfMeasure :{
    KG: '千克',
    G: '克',
    T: '吨',
    TOWER: '台',
    PIECE: '个',
  }
}